import { useState } from "react";
import { FaBuilding } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useFirmDetail from "../../../Hooks/storageRoles/useFirmDetail";
import usePermission from "../../../Hooks/usePermission";
import useAuth from "../../../Hooks/useAuth";
import FirmTabContent from "../../../Components/Firm/storageRoles/FirmTabContent";
import FirmDetailHeaderContent from "../../../Components/Firm/FirmDetailHeaderContent";
import FirmAutoReportDrawer from "../../../Components/Firm/Tabs/FirmAutoReportDrawer";
import Page403 from "../../Page403";
import AdminDetailMenu from "../../../Components/Utils/AdminDetailMenu";
import PasswordConfirmModal from "../../../Components/Utils/PasswordConfirmModal";
import {
  DetailShell,
  DetailHeader,
  DetailTabs,
  DetailSkeleton,
  DetailNotFound,
} from "../../../Components/shared";

export default function FirmDetailRoutePage() {
  const navigate = useNavigate();
  const { hasPermission } = usePermission();
  const { auth } = useAuth();
  const [reportDrawerOpen, setReportDrawerOpen] = useState(false);
  const {
    firm,
    isAdmin,
    twoFactorEnabled,
    isFetching,
    isLoading,
    selectedTab,
    setSelectedTab,
    tabs,
    firmTypeBadge,
    firmIcon,
    alerts,
    dismissAlert,
    handleFirmUpdate,
    handleGoBack,
    handleDeleteFirm,
    handleNavigateToFirm,
    deleteModalOpen,
    setDeleteModalOpen,
    deleteFirmLoading,
  } = useFirmDetail();

  if (!firm && isLoading) {
    return <DetailSkeleton tabCount={8} sectionRows={[6, 3]} />;
  }

  if (!firm && !isLoading) {
    return (
      <DetailNotFound
        icon={FaBuilding}
        title="Firma Bulunamadı"
        message="İstenen firma bilgilerine ulaşılamadı."
        backLabel="Firmalara Dön"
        onGoBack={() => navigate("/Anasayfa/Firma")}
      />
    );
  }

  return (
    <DetailShell alerts={alerts} onDismissAlert={dismissAlert}>
      <DetailHeader onGoBack={handleGoBack} backTitle="Firmalara Dön">
        <FirmDetailHeaderContent
          firm={firm}
          firmIcon={firmIcon}
          firmTypeBadge={firmTypeBadge}
          isFetching={isFetching}
          actions={(() => {
            const menuItems = [];
            if (hasPermission("firms.delete")) {
              menuItems.push({
                label: "Firmayı Sil",
                onClick: () => setDeleteModalOpen(true),
                danger: true,
              });
            }
            return menuItems.length > 0 ? (
              <AdminDetailMenu isAdmin={isAdmin} items={menuItems} />
            ) : null;
          })()}
        />
      </DetailHeader>

      <PasswordConfirmModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteFirm}
        title="Firma Silme İşlemi"
        subtitle={`Bu işlem geri alınamaz. Lütfen şifrenizi girerek onaylayın.${twoFactorEnabled ? " İki adımlı doğrulama kodu da gereklidir." : ""}`}
        confirmButtonText="Firmayı Sil"
        isLoading={deleteFirmLoading}
        twoFactorEnabled={twoFactorEnabled}
      />

      <DetailTabs tabs={tabs} activeTab={selectedTab} onChange={setSelectedTab} />

      {/* Hiçbir sekmeye izin yoksa içerik BASILMAMALI: selectedTab başlangıç
          değerinde ("info") takılı kaldığı için sekme çubuğu boş olsa bile
          Bilgi sekmesinin içeriği render ediliyordu (kullanıcı bildirimi). */}
      {tabs.length === 0 ? (
        <Page403 />
      ) : (
      <FirmTabContent
        selectedTab={selectedTab}
        firm={firm}
        readOnly={false}
        onFirmUpdate={handleFirmUpdate}
        onNavigateToFirm={handleNavigateToFirm}
        onOpenReportSettings={
          // Müşteri ve (#209) bayi firmaları — bayide rapor bayi ağını kapsar.
          ["customer", "dealer"].includes(firm.firmType) && hasPermission("firms.editAutoReport")
            ? () => setReportDrawerOpen(true)
            : undefined
        }
      />
      )}

      <FirmAutoReportDrawer
        open={reportDrawerOpen}
        onClose={() => setReportDrawerOpen(false)}
        firm={firm}
        token={auth?.accessToken}
      />
    </DetailShell>
  );
}
